import { UserRole } from '../../types/user';
import { FeatureAsset } from '../../types/assets';
import { ImpersonationMode } from '../../types/impersonationModes';

export interface LinkDescriptor {
  label: string;
  href: string;
  glyph?: string;
  testId?: string;
  queryParams?: Record<string, string>;
  allowedRoles?: UserRole[];
  excludedRoles?: UserRole[];
  allowedContryCodes?: string[];
  excludedContryCodes?: string[];
  allowedFeatureAssets?: FeatureAsset[];
  requiredFeatureFlags?: string[];
  excludedByFeatureFlag?: string[];
  allowedImpersonationModes?: ImpersonationMode[];
  excludedImpersonationModes?: ImpersonationMode[];
  isActiveRegexs?: RegExp[];
}

export interface MenuDescriptor {
  id: string,
  label: string;
  glyph: string;
  links: LinkDescriptor[];
}

export interface NavigationLink {
  label: string;
  href: string;
  glyph: string;
  testId?: string;
  isActive: boolean;
}

export enum UrlPlaceholders {
  ROOT_URL = '{{ROOT_URL}}',
  QUERY_PARAMS = '{{QUERY_PARAMS}}',
}
